import React, { useRef, useState } from "react"
import { Tooltip } from "antd"

interface Props {
    children: React.ReactNode
    maxLines?: number
    className?: string
    tooltipText?: string
}

export function EllipsisCell({ children, maxLines = 2, className = "", tooltipText }: Props) {
    const textRef = useRef<HTMLDivElement>(null)
    const [showTooltip, setShowTooltip] = useState(false)
    const [textContent, setTextContent] = useState("")

    // Only check overflow on mouse enter (lazy evaluation)
    const handleMouseEnter = () => {
        const element = textRef.current
        if (!element) return

        const text = element.textContent || element.innerText || ""
        setTextContent(text)

        // Simple check: if scrollHeight > clientHeight, text is truncated
        const isOverflowing = element.scrollHeight > element.clientHeight
        setShowTooltip((isOverflowing || !!tooltipText) && text.trim().length > 0)
    }

    const handleMouseLeave = () => {
        setShowTooltip(false)
    }

    const cellStyle: React.CSSProperties = {
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        lineHeight: "1.4",
        maxHeight: `${maxLines * 1.4}em`
    }

    const cellContent = (
        <div
            ref={textRef}
            style={cellStyle}
            className={className}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}
        </div>
    )
    return (
        <Tooltip title={showTooltip ? (tooltipText || textContent) : undefined} arrow>
            <div style={{ cursor: showTooltip ? "help" : "default" }}>{cellContent}</div>
        </Tooltip>
    )
}
